<template>
  <div id="wrapper">
    <h3 class="more">Alte comunicate:</h3>
    <div
      v-for="item in items"
      :key="item.id"
      class="press-release-link"
      :class="{ active: $route.params.subsection === item.slug }"
    >
      <router-link
        :to="{
          name: 'media-subsection',
          params: {
            section: 'press',
            subsection: item.slug,
            locale: $i18n.locale
          }
        }"
        @click.native="$emit('scrollToTop')"
      >
        {{ item.title }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PressReleaseList",
  props: ["items"]
};
</script>

<style scoped>
#wrapper {
  display: flex;
  flex-direction: column;
}

.press-release-link {
  padding: 28px 82px 28px 0px;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  background-color: transparent;
  font-family: Roboto, sans-serif;
  font-size: 1.2em;
  line-height: 1.4em;
  font-weight: 300;
}

.press-release-link.active a,
.press-release-link a:hover {
  color: #090909;
}

.press-release-link a {
  text-decoration: none;
  color: #ababab;
}

.more {
  display: none;
}

@media (max-width: 767px) {
  .more {
    padding: 40px 0 20px;
    display: block;
  }
}
</style>
